import { Action, createReducer, on } from '@ngrx/store';
import * as logForwardingActions from './log-forwarding.action';
import { LogForwardingReducer } from '../log-forwarding.model';

const initialState: LogForwardingReducer = {
  organizationId: null,
};

const reducer = createReducer(
  initialState,

  on(logForwardingActions.setOrganizationId, (state, props) => ({
    ...state,
    organizationId: props.organizationId,
  }))
);

export function logForwardingReducer(state: LogForwardingReducer | undefined, action: Action) {
  return reducer(state, action);
}
